var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1797 6.44531C11.3504 6.44531 10.6758 5.77066 10.6758 4.94141V0H2.98438C1.68126 0 0.621094 1.06017 0.621094 2.36328V19.6367C0.621094 20.9398 1.68126 22 2.98438 22H15.0156C16.3187 22 17.3789 20.9398 17.3789 19.6367V6.44531H12.1797ZM4.14453 15.4688H7.26922C7.62517 15.4688 7.91375 15.7573 7.91375 16.1133C7.91375 16.4692 7.62517 16.7578 7.26922 16.7578H4.14453C3.78858 16.7578 3.5 16.4692 3.5 16.1133C3.5 15.7573 3.78858 15.4688 4.14453 15.4688ZM3.5 12.6758C3.5 12.3198 3.78858 12.0312 4.14453 12.0312H13.5977C13.9536 12.0312 14.2422 12.3198 14.2422 12.6758C14.2422 13.0317 13.9536 13.3203 13.5977 13.3203H4.14453C3.78858 13.3203 3.5 13.0317 3.5 12.6758ZM13.5977 8.59375C13.9536 8.59375 14.2422 8.88233 14.2422 9.23828C14.2422 9.59423 13.9536 9.88281 13.5977 9.88281H4.14453C3.78858 9.88281 3.5 9.59423 3.5 9.23828C3.5 8.88233 3.78858 8.59375 4.14453 8.59375H13.5977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentList);
export default __webpack_public_path__ + "static/media/ic-document-list.f908c98d1b5b97f13009415d8f8c0fdb.svg";
export { ForwardRef as ReactComponent };